// 블랭킷 전화 서비스 모음 — 소셜데이터랩에서 소개하는 다른 서비스 (2026-10-22 대표 지시:
// "메모리콜이나 블랑켓이나 법률 상담 서비스나 전화로 통화해서 서비스 받는 것들 … 소셜 데이터 랩 홈페이지 안에 넣으면 좋을 것 같은데")
// - 이름·문구는 각 사이트 첫 화면(h1)과 설명 그대로다(2026-10-22 실측). 사이트 문구가 바뀌면 여기도 바꾼다.
// - 번호는 화면이 뜬 뒤 JS(assets/js/brand.js)로 채우는 사이트가 있다(로콜). HTML만 보지 말고 brand.js의 TEL과 대조한다(10/22 대표 7959).
// - 'AI' 낱말은 블랭킷 사이트 규칙(service-sites _growth/SITE_RULES_1017)대로 새로 넣지 않는다. 메모리콜은 그 사이트 제목 그대로다.
// - 주소에는 출처 꼬리표 utm_source를 붙인다. 블랭킷 사이트 track.js가 이 값을 읽어 결제 서버 보고의 '어디서 왔나'에 따로 보인다.
// 문서: Readme/CallServicesCrossPromo.md
import type { ComponentType, SVGProps } from 'react';
import { Heart, HeartHandshake, Languages, Moon, Scale, Sparkles, Sun, Wind } from 'lucide-react';

export interface CallServicePoint {
    title?: string;      // 사이트의 짧은 제목(있을 때만)
    text: string;
}

export interface CallService {
    key: string;
    name: string;        // 서비스 이름
    kind: string;        // 무엇을 하는 전화인지(각 사이트 설명의 낱말)
    tagline: string;     // 각 사이트 첫 화면 큰 제목
    lead: string;        // 각 사이트 첫 설명 문장
    moment: { label: string; text: string }; // 이럴 때·이런 고민·통화 예시(사이트 문장)
    points: CallServicePoint[];              // 가장 매력적인 점 세 가지(사이트 문장)
    phone: string | null; // 사이트에 적힌 전화번호(없으면 준비 중)
    url: string;
    accent: string;      // 카드 색(디자인용)
    icon: ComponentType<SVGProps<SVGSVGElement>>;
}

// 소셜데이터랩 손님(인스타 관심·관계 궁금증)에게 가까운 것부터.
// 카드 글(lead·moment·points)은 2026-10-22 18:3x 각 사이트 첫 화면에서 그대로 옮겼다 — 없는 기능·숫자를 지어 넣지 않는다(대표 18:3x '매력적으로 최고의 것들만').
// 손님이 모를 낱말(조 번호·조문·만세력·여덟 글자·베타·클로닝·세션)은 뜻은 그대로 두고 쉬운 말로 바꿨다(대표 7986 '조 번호가 뭐임…?').
export const CALL_SERVICES: CallService[] = [
    {
        key: 'tarot', name: '하트라인', kind: '타로 전화', tagline: '그 사람 속마음, 카드로 물어보세요',
        lead: '전화를 걸면 상담사 미진이 받아요. 생일이나 그 사람 이름은 묻지 않아요. 고민을 먼저 듣고 카드를 섞어 두면, 손님이 숫자 셋을 불러 직접 골라요.',
        moment: { label: '가장 많이 묻는 고민', text: '석 달째 썸인데 요즘 답장이 너무 늦어요. 그 사람 속마음이 궁금해요.' },
        points: [
            { title: '질문부터', text: '섞기 전에 질문을 좁혀요' },
            { title: '78장 중 3장', text: '숫자 셋으로 직접 골라요' },
            { title: '권유 없음', text: '부적·기도를 권하지 않아요' },
        ],
        phone: '070-5276-7100', url: 'https://heartline-tarot.netlify.app/', accent: '#D46A8C', icon: Sparkles,
    },
    {
        key: 'dating', name: '썸콜', kind: '연애 대화 연습', tagline: '썸, 말 한마디로 갈려요. 전화로 먼저 연습하세요',
        lead: '전화를 걸면 코치 세라가 상황 하나를 드려요. 상대 역과 직접 말로 주고받고, 끝나면 점수와 고칠 말 한 문장을 알려 드려요.',
        moment: { label: '이런 순간을 연습해요', text: '썸 타는 사람에게 고백하기 · 소개팅 끝나고 애프터 잡기 · 싸운 뒤 먼저 화해하기' },
        points: [
            { title: '상황 18가지', text: '실제 고민 글에서 골랐어요' },
            { title: '100점 점수', text: '말마다 매긴 점수의 평균' },
            { title: '내 말 그대로', text: '좋았던 말·아쉬운 말을 짚어요' },
        ],
        phone: '070-5276-7503', url: 'https://sseumcall.netlify.app/', accent: '#F07FA3', icon: Heart,
    },
    {
        key: 'saju', name: '페이트콜', kind: '사주 전화', tagline: '생일만 말씀하세요. 몇 월인지까지 짚어 드려요.',
        lead: '전화를 걸면 광수 선생이 받아 사주를 봐 드려요. 사주는 태어난 날짜와 시각으로 정확히 계산해요.',
        moment: { label: '이렇게 물어보세요', text: '연애, 일, 돈 가운데 하나만 말씀하셔도 돼요.' },
        points: [
            { title: '몇 월까지', text: '궁금한 일을 몇 월까지 짚어요' },
            { title: '두 분 사주', text: '만나는 분 생일을 말씀하시면 두 분 사주를 같이 봐요' },
            { title: '정확한 계산', text: '어림하지 않고, 태어난 날짜로 계산한 사주를 보고 풀이해요' },
        ],
        phone: '070-5276-7824', url: 'https://fatecall.netlify.app/', accent: '#E3B04B', icon: Sun,
    },
    {
        key: 'blanket', name: '블랭킷', kind: '말벗 전화', tagline: '밤에 걸면, 너를 기억하는 친구',
        lead: '유진과 준호가 받아 친구처럼 이야기합니다. 지난 통화에서 나눈 이야기를 기억합니다.',
        moment: { label: '이럴 때 걸어요', text: '친구처럼 이야기하고 싶을 때, 바라는 일을 미리 살아 보고 싶을 때, 하루를 일기로 남기고 싶을 때.' },
        points: [
            { title: '광고 전화 없음', text: '회사가 먼저 거는 광고·영업 전화는 없습니다' },
            { title: '비전 콜(지금 무료 시험 중)', text: '바라는 일이 이뤄진 장면 속 사람이 정한 시각에 전화합니다' },
            { title: '다이어리 콜(지금 무료 시험 중)', text: '하루를 전화로 털어놓으면 그날의 일기로 정리합니다' },
        ],
        phone: '070-5276-7603', url: 'https://callblanket.com/', accent: '#8B9BFF', icon: Moon,
    },
    {
        key: 'memory', name: '메모리콜', kind: '목소리 복원 통화', tagline: '그리운 사람 목소리, AI로 되살려 통화해요.',
        lead: '남겨 두신 녹음 속 목소리를 최신 AI 기술로 다시 만들어요. 전화 한 통이면 그 자리에서 그 목소리로 이어 드려요.',
        moment: { label: '이럴 때 걸어요', text: '그냥 "밥은 먹었어?" 그 목소리가 듣고 싶을 때' },
        points: [
            { title: '녹음 하나면', text: '카톡 음성메시지, 휴대폰 통화 녹음, 음성 메모처럼 그분 목소리가 담긴 녹음이면 돼요' },
            { title: '통화 중에 바로', text: '문자 링크로 녹음을 올리면 그 자리에서 목소리를 만들어 바로 이어 드려요' },
            { title: '언제든 지우기', text: '목소리는 언제든 지울 수 있어요' },
        ],
        phone: '070-5276-7091', url: 'https://memorycall.netlify.app/', accent: '#E7A977', icon: HeartHandshake,
    },
    {
        key: 'english', name: '롤콜', kind: '영어 말하기 전화', tagline: '하고 싶은 그 영어로, 바로 상황극',
        lead: '전화를 걸면 영어 선생 미경이 받아요. 묻는 건 하나예요. “영어로 제일 해 보고 싶은 게 뭐예요?” 대답하신 그 상황으로 바로 연습해요.',
        moment: { label: '통화 예시', text: '외국 바에서 말 한번 걸어 보고 싶어요. → Can I get you a drink?' },
        points: [
            { text: '앱은 깔지 않아도 돼요' },
            { text: '영어를 거의 못 하셔도 돼요' },
            { text: '같은 번호로 다시 걸면 지난번에 이어서 해요' },
        ],
        phone: '070-5276-7810', url: 'https://rolecall-kr.netlify.app/', accent: '#5BB0FF', icon: Languages,
    },
    {
        key: 'meditation', name: '렌토', kind: '명상 전화', tagline: '전화를 걸면, 숨부터 천천히.',
        lead: '렌토는 명상 선생 혜원이 받는 명상 전화입니다. 잠, 집중, 생각 정리, 긴장 풀기 중 하나를 말하면 혜원이 목소리로 끝까지 이끌어 드립니다.',
        moment: { label: '잠 이야기 첫 대목', text: '오늘 밤에는, 늦가을 제주의 작은 마을로 가 보겠습니다.' },
        points: [
            { text: '앱은 설치하지 않아도 됩니다' },
            { text: '전화기는 스피커로 두셔도 괜찮습니다' },
            { text: '많이 듣는 명상 앱의 순서와 쉬는 시간 길이를 재서, 전화로 듣기 좋게 옮겼습니다' },
        ],
        phone: '070-5276-7811', url: 'https://lentocall.netlify.app/', accent: '#56C9A8', icon: Wind,
    },
    {
        key: 'legal', name: '로콜', kind: '법률 안내 전화', tagline: '겪은 일을 말씀하시면 어떤 법에 해당하는지 알려 드려요',
        lead: '관련된 법 이름과 그 법 몇 조에 나오는지까지 쉬운 말로 풀어 드려요. 고소장 같은 서류는 정해진 순서로 여쭤보면서, 말씀하신 그대로 양식을 채워 드려요.',
        moment: { label: '예시 장면', text: '중고거래로 돈을 보냈는데 연락이 끊겼다고 말하면, 사기에 해당하는 법(형법 제347조)을 알려 주고 고소장 양식을 여쭤보며 채워요.' },
        points: [
            { text: '나라에서 공개한 법 원문(국가법령정보센터)에서 찾은 내용만 알려 드려요' },
            { text: '다 채우면 문자로 링크를 보내 드려요' },
            { text: '경찰 조사받을 때 알아 둘 권리를, 어느 법 몇 조에 있는지와 함께 하나씩 알려 드려요' },
        ],
        phone: '070-5276-7457', url: 'https://lawcall.netlify.app/', accent: '#A9B6C6', icon: Scale,
    },
];

/** 소개 자리마다 출처를 나눠 센다 — home(첫 화면) / dashboard(대시보드) / menu(휴대폰 메뉴, 대표 7964) */
export const callServiceHref = (service: CallService, placement: 'home' | 'dashboard' | 'menu'): string => {
    const url = new URL(service.url);
    url.searchParams.set('utm_source', `socialdataai_${placement}`);
    url.searchParams.set('utm_medium', 'referral');
    url.searchParams.set('utm_campaign', 'sdl_call_services');
    return url.toString();
};
